import { render } from "./2024s_EventHistory2.vue?vue&type=template&id=4aa1e52d"
import script from "./2024s_EventHistory2.vue?vue&type=script&lang=js"
export * from "./2024s_EventHistory2.vue?vue&type=script&lang=js"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__